import { UseQueryResult } from "@tanstack/react-query";

export enum ContentfulPage {
  HOME = "Home Page",
  CREATE_ACCOUNT = "Create Account Page",
  CHECKOUT = "Checkout Page",
  CONFIRMATION = "Confirmation Page"
}
export interface ImageComponent {
  url: string;
}
export interface MerchandiseBanner {
  title: string;
  targetUrl: string;
  altText: string;
  desktopImage: ImageComponent;
  mobileImage: ImageComponent;
  __typename: string;
}

export interface UiScopedContent {
  content: MerchandiseBanner;
  title: string;
  __typename: string;
}

export interface SectionsComponent {
  contentCollection : {
    items: UiScopedContent[];
  };
}

export interface UIPageContent {
  sectionsCollection: {
    items: SectionsComponent[];
  };
}

export interface PageDataResponse {
  data: {
    uiPageCollection: {
      items: UIPageContent[];
    };
  };
}

export interface PageData {
  merchandiseBannerLegacyV2Data?: MerchandiseBanner;
}

export type PageContentQueryResult = UseQueryResult<PageData, Error>;